// extracted by mini-css-extract-plugin
export var modal__header = "Modal-module--modal__header--kvTEI";
export var modal__content = "Modal-module--modal__content--zifho";
export var modal__active = "Modal-module--modal__active--nn235";
export var modal__inactive = "Modal-module--modal__inactive--XwjTP";
export var modal__overlay = "Modal-module--modal__overlay--nSiqt";
export var modal__overlay__hidden = "Modal-module--modal__overlay__hidden--zdLmX";